import React, { useEffect } from "react";
import { Button, Dropdown, TextInput } from "flowbite-react";
import PBLogo from "../../Assets/PriceBros-Logo.png";
import { useAppDispatch, useAppSelector } from "../../Reducers/store";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { SearchRequest } from "../../Models/SearchRequest";
import { toast } from "react-toastify";
import { fetchCurrentUser } from "../../Actions";
import { HiMenu } from "react-icons/hi";
import { MdShoppingCart } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { UserLevelNames } from "../../Models/UserLevel";
import { useLocation } from "react-router-dom";

export default function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);

  const logout = () => {
    localStorage.removeItem("PriceBrosToken");
    dispatch(fetchCurrentUser());
  };

  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem("searchTextState") ?? "",
    searchPartsText: localStorage.getItem("searchPartsTextState") ?? "",
    manufacturers: null,
    categories: null,
    subCategories: null,
    minPrice: null,
    maxPrice: null,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 1,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [orderItemsCount, setOrderItemsCount] = useState<number>(0);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    localStorage.setItem("manufacturersState", "");
    localStorage.setItem("categoriesState", "");
    localStorage.setItem("subCategoriesState", "");
    localStorage.setItem("minPriceState", "");
    localStorage.setItem("maxPriceState", "");
    localStorage.setItem("equipmentTypeState", "1");
    localStorage.setItem("searchTextState", formData.searchText ?? "");
    setFormData((prevData) => ({ ...prevData }));
    //navigate('/products/search', { replace: true });
    //navigate(`/products/search?ts=${Date.now()}`, { replace: true });
    if (location.pathname === "/products/search") {
      navigate(0); // force reload
    } else {
      navigate("/products/search");
    }
  };
  const onPartsSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    localStorage.setItem("manufacturersState", "");
    localStorage.setItem("categoriesState", "");
    localStorage.setItem("subCategoriesState", "");
    localStorage.setItem("minPriceState", "");
    localStorage.setItem("maxPriceState", "");
    localStorage.setItem("equipmentTypeState", "2");
    localStorage.setItem(
      "searchPartsTextState",
      formData.searchPartsText ?? ""
    );
    setFormData((prevData) => ({ ...prevData }));
    //navigate('/products/search/parts', { replace: true });
    //navigate(`/products/search/parts?ts=${Date.now()}`, { replace: true });
    if (location.pathname === "/products/search/parts") {
      navigate(0); // force reload
    } else {
      navigate("/products/search/parts");
    }
  };

  const handlePartsClick = () => {
    localStorage.setItem("manufacturersState", "");
    localStorage.setItem("categoriesState", "");
    localStorage.setItem("subCategoriesState", "");
    //localStorage.setItem('searchPartsTextState', '');
    localStorage.setItem("minPriceState", "");
    localStorage.setItem("maxPriceState", "");
    localStorage.setItem("equipmentTypeState", "2");
    navigate("/products/search/parts", { replace: true });
  };

  useEffect(() => {
    const count =
      localStorage.getItem("orderItemsCount") &&
      Number(localStorage.getItem("orderItemsCount")) >= 0
        ? Number(localStorage.getItem("orderItemsCount"))
        : 0;
    setOrderItemsCount(count);
    function checkOrderItemsCount() {
      const count =
        localStorage.getItem("orderItemsCount") &&
        Number(localStorage.getItem("orderItemsCount")) >= 0
          ? Number(localStorage.getItem("orderItemsCount"))
          : 0;
      setOrderItemsCount(count);
    }

    window.addEventListener("updateOrderItemCount", checkOrderItemsCount);

    return () => {
      window.removeEventListener("updateOrderItemCount", checkOrderItemsCount);
    };
  }, []);

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel?.userLevelId === UserLevelNames.Admin) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className="w-full sticky top-0 z-10">
        <div className="flex flex-wrap bg-black px-4 py-3 justify-between items-center min-h-[64px]">
          <Link to={"/"} className="w-[70px]">
            {/* <Navbar.Brand href='/'> */}
            <img src={PBLogo} className="mr-3 h-12" alt="Price Bros" />
            {/* </Navbar.Brand> */}
          </Link>
          <div className="w-full px-2 py-3 flex flex-col gap-2 lg:flex-row lg:w-1/3 lg:items-center">
            {/* Search Equipment */}
            <form
              onSubmit={onSubmit}
              className="flex flex-col sm:flex-row gap-2 w-full lg:w-1/2"
            >
              <TextInput
                id="searchText"
                name="searchText"
                type="text"
                placeholder="Search Equipment..."
                onChange={handleChange}
                value={formData.searchText ?? ""}
                className="w-full"
              />
              <Button type="submit" className="buttonMain w-full sm:w-auto">
                Search
              </Button>
            </form>

            {/* Search Parts */}
            <form
              onSubmit={onPartsSubmit}
              className="flex flex-col sm:flex-row gap-2 w-full lg:w-1/2"
            >
              <TextInput
                id="searchPartsText"
                name="searchPartsText"
                type="text"
                placeholder="Search Parts..."
                onChange={handleChange}
                value={formData.searchPartsText ?? ""}
                className="w-full"
              />
              <Button
                type="submit"
                className="buttonMain w-full sm:w-auto whitespace-nowrap"
              >
                Search Parts
              </Button>
            </form>
          </div>

          <div className="flex my-auto">
            <div className="hidden lg:flex">
              <Link to={"/"}>
                <Button className="text-white">Home</Button>
              </Link>
              <Link to={"/products/manufacturers"}>
                <Button className="text-white">Manufacturers</Button>
              </Link>
              <Link to={"/products/categories"}>
                <Button className="text-white px-0">Wholegoods</Button>
              </Link>

              <Link to={"/manuals"}>
                <Button className="text-white px-0">Manuals</Button>
              </Link>
              <Button onClick={handlePartsClick} className="text-white px-0">
                Parts
              </Button>
              <Dropdown arrowIcon={false} label={"Warranty"}>
                <Link
                  className="flex content-center py-1 px-2 hover:bg-gray-100"
                  to={"/warranty/claim"}
                >
                  New Claim
                </Link>
                {userModel && (
                  <Link
                    className="flex content-center py-1 px-2 hover:bg-gray-100"
                    to={"/warranty/myclaims"}
                  >
                    View Claims
                  </Link>
                )}
              </Dropdown>
              <Link to={"/dealerlocator"}>
                <Button className="text-white px-0">Dealer Locator</Button>
              </Link>
              <Link to={"/contact"}>
                <Button className="text-white px-0">Contact</Button>
              </Link>
              {userModel && (
                <Link
                  to={"/orders/view"}
                  className="relative inline-flex m-auto px-2"
                >
                  <MdShoppingCart color="white" size={20} />
                  {orderItemsCount > 0 && (
                    <span className="absolute rounded-full text-xs font-medium flex justify-center place-items-center translate-x-3/4 -translate-y-3/4 bg-red-500 text-white w-[20px] h-[20px]">
                      {orderItemsCount}
                    </span>
                  )}
                </Link>
              )}
              <div className="mx-2"></div>
              {!userModel && (
                <Link to={"/login"}>
                  <Button>Dealer Login</Button>
                </Link>
              )}
              {userModel && (
                <Dropdown
                  arrowIcon={false}
                  label={<FaUser color="white" size={20} />}
                >
                  <Link
                    className="flex content-center py-1 px-2 hover:bg-gray-100"
                    to={`/user/${userModel?.id}`}
                  >
                    Profile
                  </Link>
                  {!checkAccess() && (
                    <Link
                      className="flex content-center py-1 px-2 hover:bg-gray-100"
                      to={`/orders/list`}
                    >
                      Orders
                    </Link>
                  )}
                  {userModel?.client?.rimssId ? (
                    <Link
                      className="flex content-center py-1 px-2 hover:bg-gray-100"
                      to="/my-invoices"
                    >
                      Invoices
                    </Link>
                  ) : null}
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={logout} className="text-red-700">
                    Logout
                  </Dropdown.Item>
                </Dropdown>
              )}
            </div>
            <div className="block lg:hidden absolute top-4 right-4 z-20 justify-left">
              <Dropdown
                label=""
                dismissOnClick={false}
                renderTrigger={() => (
                  <div>
                    <HiMenu size={35} className="text-white cursor-pointer" />
                  </div>
                )}
              >
                {(userModel?.userLevelId === UserLevelNames.Admin ||
                  userModel?.userLevelId === UserLevelNames.Employee) && (
                  <Dropdown.Item>
                    <Dropdown
                      label=""
                      dismissOnClick={true}
                      renderTrigger={() => <div>Admin</div>}
                      placement="left"
                    >
                      <Dropdown.Item>
                        <Link to="/users">Users</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/clients">Clients</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/manufacturers">Manufacturers</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/categories">Categories</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/subcategories">SubCategories</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/equipmentlist">Wholegoods</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/partslist">Parts</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/manuallist">Manuals</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/admin/order/list">Orders</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/warrantylist">Warranty Claims</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/siteresources">Site Pages</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/contactforms">Potential Opportunities</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="/requestQuotes">Quote Requests</Link>
                      </Dropdown.Item>
                    </Dropdown>
                  </Dropdown.Item>
                )}
                <Dropdown.Item>
                  <Link to={"/"}>Home</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={"/products/manufacturers"}>Manufacturers</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={"/products/categories"}>Wholegoods</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={"/products/search"}>Wholegoods Search</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <div onClick={handlePartsClick} className="">
                    Parts
                  </div>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={"/manuals"}>Manuals</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Dropdown
                    label=""
                    dismissOnClick={false}
                    renderTrigger={() => <div>Warranty</div>}
                    placement="left"
                  >
                    <Dropdown.Item>
                      <Link className="" to={"/warranty/claim"}>
                        New Claim
                      </Link>
                    </Dropdown.Item>
                    {userModel && (
                      <Dropdown.Item href={"/warranty/myclaims"}>
                        View Claims
                      </Dropdown.Item>
                    )}{" "}
                  </Dropdown>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={"/dealerlocator"}>Dealer Locator</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={"/contact"}>Contact</Link>
                </Dropdown.Item>
                {userModel && (
                  <Dropdown.Item>
                    <Link className="flex gap-2" to={"/orders/view"}>
                      Cart
                      {orderItemsCount > 0 && (
                        <span className="rounded-full text-xs font-medium flex justify-center place-items-center bg-red-500 text-white w-[20px] h-[20px]">
                          {orderItemsCount}
                        </span>
                      )}
                    </Link>
                  </Dropdown.Item>
                )}
                {userModel?.client?.rimssId ? (
                  <Dropdown.Item>
                    <Link to="/my-invoices">Invoices</Link>
                  </Dropdown.Item>
                ) : null}
                <Dropdown.Item>
                  {!userModel && (
                    <Link to={"/login"} className="text-green-600">
                      Dealer Login
                    </Link>
                  )}
                  {userModel && (
                    <div onClick={logout} className="text-red-500">
                      Logout
                    </div>
                  )}
                </Dropdown.Item>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
